// extracted by mini-css-extract-plugin
module.exports = {"SitterSignup":"styles_SitterSignup__3Gy6S"};